// Clip holiday display to this day's visible hours, preserving original dates.
export function absenceDisplay(block, day, firstHour, lastHour) {
  if (!block.is_absence) return block;
  const start = new Date(`${block.date_from}T00:00:00`);
  const end = new Date(`${block.date_to}T00:00:00`);
  end.setDate(end.getDate() + 1);
  const visibleStart = new Date(day); visibleStart.setHours(firstHour, 0, 0, 0);
  const visibleEnd = new Date(day); visibleEnd.setHours(lastHour + 1, 0, 0, 0);
  if (!(start < visibleEnd && end > visibleStart)) return null;
  return { ...block, display_start: visibleStart, display_end: visibleEnd };
}
